<template>
  <div class="right">
    <div style="text-align:center;font-weight:900;font-size:0.16rem;margin:0.4rem 0.2rem 0.2rem 0.2rem">
      ISO20000-X信息技术服务管理体系系列标准介绍</div>
    <div style="text-align:right">
      <p>编辑整理 吴超、1DING</p>
      <p>整理日期 2019年6月</p>
    </div>
    <p style="margin-top:0.2rem">
      ISO20000系列标准从BSI发布的英国标准BS15000:1995开始，经过近24年的发展，截止2019年4月30日，已经正式发布的标准有10项了。其中有2项已经被吸纳为国家标准。</p>
    <p style="font-weight:700">其中吸纳为国标的为核心标准，包括</p>
    <ul>
      <li>
        <p>GB/T 24405.1-2009/ISO/IEC 20000-1:2005 信息技术服务管理 第1部分:规范</p>
      </li>
      <li>
        <p>GB/T 24405.2-2009/ISO/IEC 20000-2:2005 信息技术服务管理 第2部分：实践规则</p>
      </li>
    </ul>
    <p>已发布的10项标准除了覆盖常规的术语概念、基本要求、实践指南、审核要求之外，还对具体的云服务行业、实施过程和体系融合等方面制定了相应的标准。</p>
    <div style="max-width:8rem;margin:0 auto -5.5rem auto;padding:0">
      <svg width="700" height="1090" viewBox="0,0,800,1108" preserveAspectRatio="xMinYMin meet" id="svg"></svg>
    </div>
    <p>已发布的10项标准主要涵盖：</p>
    <subitem :data="serials[0].children" />
    <p>&nbsp;</p>
  </div>
</template>

<script>
  import subitem from '@/components/tech/subitem.vue';
  import * as d3 from "d3";
  import axios from "axios";
  import global_ from "@/misc/global.vue";
  export default {
    components: {
      subitem
    },
    data() {
      return {
        description: {
          standards_code: "",
          standards_name: "",
          related_standards_code: "",
          serials: ""
        },
        serials: [{
          name: "ISO20000系列",
          id: "0",
          children: [{
              name: "术语概念（1项）",
              id: "0-1",
              children: [{
                name: "ISO/IEC 20000-10:2018  信息技术 - 服务管理 - 第10部分：概念和术语",
                open: "ISO/IEC 20000-10:2018"
              }]
            },
            {
              name: "基本要求（2项）",
              id: "0-2",
              children: [{
                  name: "ISO/IEC 20000-1:2018  信息技术 - 服务管理 - 第1部分：服务管理体系要求",
                  open: "ISO/IEC 20000-1:2018"
                },
                {
                  name: "ISO/IEC 20000-6:2017  信息技术 - 服务管理 - 第6部分：认证审核机构要求",
                  open: "ISO/IEC 20000-6:2017"
                }
              ]
            },
            {
              name: "云服务指南（1项）",
              id: "0-3",
              children: [{
                  name: "ISO/IEC 20000-9:2015  信息技术 - 服务管理 - 第9部分：ISO/IEC 20000-1云服务应用指南",
                  open: "ISO/IEC 20000-9:2015"
                }
              ]
            },
            {
              name: "实施指南（4项）",
              id: "0-4",
              children: [{
                  name: "ISO/IEC 20000-2:2012  信息技术 - 服务管理 - 第2部分：服务管理体系应用指南",
                  open: "ISO/IEC 20000-2:2012"
                },
                {
                  name: "ISO/IEC 20000-3:2012  信息技术 - 服务管理 - 第3部分：ISO/IEC 20000-1适用性指南",
                  open: "ISO/IEC 20000-3:2012"
                },
                {
                  name: "ISO/IEC 20000-4:2010  信息技术 - 服务管理 - 第4部分：过程参考模型",
                  open: "ISO/IEC 20000-4:2010"
                },
                {
                  name: "ISO/IEC 20000-5:2013  信息技术 - 服务管理 - 第9部分：ISO/IEC 20000-1实施范例",
                  open: "ISO/IEC 20000-5:2013"
                }
              ]
            },
            {
              name: "体系融合（2项）",
              id: "0-5",
              children: [{
                  name: "ISO/IEC 20000-11:2015  信息技术 - 服务管理 - 第11部分：ISO/IEC 20000-1与服务管理框架ITIL指南",
                  open: "ISO/IEC 20000-11:2015"
                },
                {
                  name: "ISO/IEC 20000-12:2016  信息技术 - 服务管理 - 第12部分：ISO/IEC 20000-1与服务管理框架CMMI指南",
                  open: "ISO/IEC 20000-12:2016"
                }
              ]
            }
          ]
        }],
        tree: "",
        links: [],
        links_postion: []
      };
    },

    mounted() {
      var self = this;
      var svg = d3.select("#svg");

      self.tree = d3.hierarchy(self.serials[0]);
      self.links = self.tree.links();
      self.tree.eachAfter(function (d) {
        if (!d.data.id) {
          d.data.id = d.data.open
            .replace(" ", "")
            .replace(":", "-")
            .replace("/", "-");
        }
      });

      // 绘制标准清单
      self.itemDraw(svg, "std", self.tree, 0, 0);

      // 绘制标准间连接线
      self.tree.eachAfter(function (d) {
        d.x = 0;
        d.y = 0;
      });
      for (let i = 0; i < self.links.length; i++) {
        self.links[i].source.x = parseInt(
          document
          .getElementById("std" + self.links[i].source.data.id)
          .getAttribute("x")
        );
        self.links[i].source.y =
          parseInt(
            document
            .getElementById("std" + self.links[i].source.data.id)
            .getAttribute("y")
          ) + 20;

        self.links[i].target.x = parseInt(
          document
          .getElementById("std" + self.links[i].target.data.id)
          .getAttribute("x")
        );
        self.links[i].target.y =
          parseInt(
            document
            .getElementById("std" + self.links[i].target.data.id)
            .getAttribute("y")
          ) + 20;
      }
      self.linkDraw(svg, self.links);
    },

    methods: {
      openStardards(para) {
        var self = this;
        // 首先获取标准号
        axios
          .get(global_.BAK_URL + "getStandardsDescription/", {
            params: {
              keywords: para
            },
            async: false
          })
          .then(response => {
            // 再根据标准号，打开标准条款
            var newWindow = window.open();
            const {
              href
            } = self.$router.resolve({
              path: "/showStandards",
              query: {
                standards_code: response.data[0].standards_code,
                standards_name: response.data[0].standards_name,
                related_standards_code: response.data[0].related_standards_code,
                serials: response.data[0].serials
              }
            });
            newWindow.location.href = href;
          });
      },

      itemDraw(draw, id, para, x, y) {
        // draw 画布
        // id 对应相应的元素集/缩写
        // x 表示左缩进格数，每格20
        // y 表示下移格数，每格30
        // top 表示是否为第一个，数字为true,false
        let self = this;
        draw = draw.append("g")
          .on("click", function () {
            if (!para.children) {
              self.openStardards(para.data.open);
            }
          })
          .on("touchstart", function () {
            if (!para.children) {
              self.openStardards(para.data.open);
            }
          });

        draw.append("rect").attrs({
          id: id + para.data.id,
          x: x * 40,
          y: y * 40,
          height: 40,
          width: 600 - x * 40,
          stroke: "none",
          fill: "none"
        });
        draw
          .append("text")
          .text(function () {
            if (document.documentElement.clientWidth > 600) {
              return para.data.name
            } else {
              if (para.data.open) {
                return para.data.name.split(/:|\s+/i)[1] + " " +
                  para.data.name.split(/:|\s+/i)[para.data.name.split(/:|\s+/i).length - 1]
              } else {
                return para.data.name
              }
            }
          })
          .attrs({
            x: x * 40 + 10,
            y: y * 40 + 20,
            "alignment-baseline": "baseline",
            "dominant-baseline": "middle",
            "text-anchor": "start",
            fill: "#2f2f2f",
            style: function () {
              if (para.children) {
                return "font-size: 14px;font-weight:900; color:'white'";
              } else {
                return "font-size: 14px; font-family:'阿里巴巴普惠体 L'; color:'white'";
              }
            }
          });
        if (para.children) {
          x = x + 1;
          y = y + 1;
          for (let i = 0; i < para.children.length; i++) {
            let a = 0;
            for (let j = 0; j < i; j++) {
              a = a + para.children[j].descendants().length;
            }
            self.itemDraw(draw, id, para.children[i], x, y + a);
          }
        }
      },

      // 绘图（连线）
      linkDraw(draw, data) {
        const link = draw.selectAll("line").data(data);

        link
          .enter()
          .append("path")
          .attr("d", function (d) {
            return (
              "M" +
              d.source.x +
              "," +
              d.source.y +
              "L" +
              d.source.x +
              "," +
              d.target.y +
              "L" +
              d.target.x +
              "," +
              d.target.y
            );
          })
          .attr("stroke", "black")
          .attr("stroke-width", "1px")
          .attr("fill", "none");

        link
          .enter()
          .append("path")
          .attr("d", function (d) {
            return (
              "M" +
              (d.source.x - 5) +
              "," +
              d.source.y +
              "L" +
              d.source.x +
              "," +
              (d.source.y + 5) +
              "L" +
              (d.source.x + 5) +
              "," +
              d.source.y +
              "L" +
              d.source.x +
              "," +
              (d.source.y - 5) +
              "L" +
              (d.source.x - 5) +
              "," +
              d.source.y
            );
          })
          .attr("stroke", "none")
          .attr("fill", "#4f4f4f");
      }
    }
  };
</script>

<style scoped>
  .right {
    width: 100%;
  }

  .right .svg {
    display: block;
    padding: 0;
    height: 100%;
    width: 100%;
  }

  .right ul {
    margin: 0 0.1rem;
    padding: 0 0.1rem;
  }

  .right * {
    line-height: 0.27rem;
  }
</style>